module.exports = __webpack_public_path__ + "media/images/boxes-6af24342f5c45dfa61db486bc64becf7.svg";